import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import PublicRoute from "./PublicRoute";
import VerifyRoute from "./VerifyRoute";
import DynamicGate from "./dynamicGate";
import PrivateRoute from "./PrivateRoute";
import PageViewTracker from "./pageViewTracker";
import { Paths } from "../common/constants";
import ScrollToTop from "../components/scroll-to-top";
import LazyLoader from "../components/routesContainer";
import BlockChainCoADetails from "../pages/block-chain-coa-details";

const MyLibrary = LazyLoader(lazy(() => import("../pages/my-library")));
const Signup = LazyLoader(
  lazy(() => import("../pages/user-authentication/signup")),
);
const Support = LazyLoader(
  lazy(() => import("../pages/user-authentication/support")),
);
const LoginWrapper = LazyLoader(
  lazy(() => import("../components/layout/login-wrapper")),
);
const Login = LazyLoader(
  lazy(() => import("../pages/user-authentication/login")),
);
const Otp = LazyLoader(lazy(() => import("../pages/user-authentication/otp")));
const SuccessfulRegister = LazyLoader(
  lazy(() => import("../pages/user-authentication/successful-register")),
);
const SupportRequestSuccess = LazyLoader(
  lazy(() => import("../pages/user-authentication/support/report-request")),
);
const Announcements = LazyLoader(lazy(() => import("../pages/announcements")));
const AnnouncementDetail = LazyLoader(
  lazy(() => import("../pages/announcements/announcement-detail")),
);
const LoginWithEmail = LazyLoader(
  lazy(() => import("../pages/user-authentication/login/loginWithEmail")),
);
const UserNotificationPreferences = LazyLoader(
  lazy(() => import("../pages/settings/notification-preferences")),
);
const MyProfile = LazyLoader(lazy(() => import("../pages/profile")));

const EditProfile = LazyLoader(
  lazy(() => import("../pages/profile/edit-profile")),
);
const VerifyEmail = LazyLoader(
  lazy(() => import("../pages/profile/edit-profile/verify")),
);
const FAQ = LazyLoader(lazy(() => import("../pages/settings/faq")));
const UserSupport = LazyLoader(lazy(() => import("../pages/support")));
const Notifications = LazyLoader(lazy(() => import("../pages/notifications")));
const UserSupportSuccess = LazyLoader(
  lazy(() => import("../pages/support/successpage")),
);
const ScanProduct = LazyLoader(lazy(() => import("../pages/scan-product")));
const StrainDetails = LazyLoader(
  lazy(() => import("../pages/strain/strainDetails")),
);

const ReviewList = LazyLoader(
  lazy(() => import("../pages/review/review-list")),
);

const Manufacture = LazyLoader(
  lazy(() => import("../pages/manufacture/manufactureDetails")),
);

const RewardDetails = LazyLoader(
  lazy(() => import("../pages/rewards/rewardDetails")),
);

const ProductDetails = LazyLoader(
  lazy(() => import("../pages/scan-product/product-details")),
);

const BlockChainProduct = LazyLoader(
  lazy(() => import("../pages/block-chain-view")),
);

const CompoundListing = LazyLoader(
  lazy(() => import("../pages/compound-listing")),
);

const CompoundDetails = LazyLoader(
  lazy(() => import("../pages/compound-listing/compound-details")),
);

const NoCompoundDetailsFound = LazyLoader(
  lazy(() => import("../pages/compound-listing/compound-details/no-detail")),
);

//for rate- product

const ProductReview = LazyLoader(
  lazy(() => import("../pages/review/product-review/index")),
);

//ribbons detail page
// const RibbonsDetails = LazyLoader(
//   lazy(() => import("../pages/rewards/ribbon-Details/index"))
// );

const Badges = LazyLoader(lazy(() => import("../pages/badges")));

const BrandDirectory = LazyLoader(
  lazy(() => import("../pages/brand-directory")),
);

const CompoundsList = LazyLoader(lazy(() => import("../pages/compounds-list")));
const BatchDetails = LazyLoader(
  lazy(() => import("../pages/manufacture/batch-details")),
);
const PageNotFound = LazyLoader(lazy(() => import("../pages/not-found")));

const RoutesManager = () => {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <ScrollToTop />
      <DynamicGate>
        <Routes>
          <Route
            path={Paths.SIGNIN}
            element={
              <LoginWrapper
                childComp={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                }
              />
            }
          />
          <Route
            path={Paths.SIGNIN_EMAIL}
            element={
              <LoginWrapper
                childComp={
                  <PublicRoute>
                    <LoginWithEmail />
                  </PublicRoute>
                }
              />
            }
          />
          <Route
            path={Paths.SIGNUP}
            element={
              <LoginWrapper
                childComp={
                  <VerifyRoute>
                    <Signup />
                  </VerifyRoute>
                }
              />
            }
          />
          <Route
            path={Paths.VERIFY}
            element={<LoginWrapper childComp={<Otp />} />}
          />
          <Route
            path={Paths.SUPPORT}
            element={
              <PublicRoute>
                <Support />
              </PublicRoute>
            }
          />
          <Route
            path={Paths.SUPPORT_SUCCESS}
            element={<SupportRequestSuccess />}
          />
          <Route
            path={Paths.REGISTER_SUCCESS}
            element={<SuccessfulRegister />}
          />
          <Route
            path={Paths.PASSKEY_SUCCESS}
            element={<SuccessfulRegister />}
          />
          <Route
            path={`${Paths.PRODUCT_DETAILS}/:id`}
            element={<ProductDetails />}
          />
          <Route
            path={Paths.MY_LIBRARY}
            element={
              <PrivateRoute>
                <MyLibrary />
              </PrivateRoute>
            }
          />
          <Route
            path={`${Paths.LIBRARY_PRODUCT_DETAILS}/:id`}
            element={
              <PrivateRoute>
                <ProductDetails />
              </PrivateRoute>
            }
          />
          {/* rate product */}
          <Route
            path={`${Paths.LIBRARY_PRODUCT_REVIEW}/:serialNumber`}
            element={
              <PrivateRoute>
                <ProductReview />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.ANNOUNCEMENTS}
            element={
              <PrivateRoute>
                <Announcements />
              </PrivateRoute>
            }
          />
          <Route
            path={`${Paths.ANNOUNCEMENT_DETAIL}/:id`}
            element={
              <PrivateRoute>
                <AnnouncementDetail />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.FAQ}
            element={
              <PrivateRoute>
                <FAQ />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.NOTIFICATION_PREFERENCES}
            element={
              <PrivateRoute>
                <UserNotificationPreferences />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.PROFILE}
            element={
              <PrivateRoute>
                <MyProfile />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.EDIT_PROFILE}
            element={
              <PrivateRoute>
                <EditProfile />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.VERIFY_EMAIL}
            element={
              <PrivateRoute>
                <VerifyEmail />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.USER_SUPPORT}
            element={
              <PrivateRoute>
                <UserSupport />
              </PrivateRoute>
            }
          />
          {/* <Route
          path={Paths.REWARDS}
          element={
            <PrivateRoute>
              <Rewards />
            </PrivateRoute>
          }
        /> */}
          <Route
            path={Paths.NOTIFICATIONS}
            element={
              <PrivateRoute>
                <Notifications />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.SCAN_PRODUCT}
            element={
              <PrivateRoute>
                <ScanProduct />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.USER_SUPPORT_SUCCESS}
            element={
              <PrivateRoute>
                <UserSupportSuccess />
              </PrivateRoute>
            }
          />
          <Route
            path={`${Paths.STRAIN_DETAILS}/:strainMongoId/:productId`}
            element={<StrainDetails />}
          />
          <Route
            path={`${Paths.STRAIN_DETAILS}/:strainMongoId`}
            element={<StrainDetails />}
          />
          <Route
            path={`${Paths.REVIEW_LIST}/:batchIndexId`}
            element={<ReviewList />}
          />
          <Route
            path={`${Paths.MANUFACTURE_DETAILS}/:manufacturerId`}
            element={<Manufacture />}
          />
          <Route
            path={`${Paths.BATCH_DETAILS}/:id`}
            element={<BatchDetails />}
          />
          <Route
            path={Paths.REWARD_DETAILS}
            element={
              <PrivateRoute>
                <RewardDetails />
              </PrivateRoute>
            }
          />
          <Route
            path={`${Paths.BLOCKCHAIN_PRODUCT}/:batchIndexId`}
            element={<BlockChainProduct />}
          />
          <Route
            path={`${Paths.BLOCKCHAIN_COA_DETAILS}/:batchIndexId`}
            element={<BlockChainCoADetails />}
          />
          <Route
            path={`${Paths.COMPOUND_LISTING}/:compound/:climsId`}
            element={<CompoundListing />}
          />
          <Route
            path={`${Paths.COMPOUND_DETAILS}/:compound`}
            element={<CompoundDetails />}
          />
          <Route
            path={`${Paths.COMPOUND_DETAILS}`}
            element={<NoCompoundDetailsFound />}
          />
          {/* <Route
          path={`${Paths.RIBBON_DETAILS}/:ribbonId`}
          element={<RibbonsDetails />}
        /> */}
          <Route
            path={Paths.BADGES}
            element={
              <PrivateRoute>
                <Badges />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.BRAND_DIRECTORY}
            element={
              <PrivateRoute>
                <BrandDirectory />
              </PrivateRoute>
            }
          />
          <Route
            path={Paths.COMPOUNDS_LIST}
            element={
              <PrivateRoute>
                <CompoundsList />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </DynamicGate>
    </BrowserRouter>
  );
};

export default RoutesManager;
